
// confirm
var swiper = new Swiper('.item-image .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    a11y: {
        enabled: true,
        slideLabelMessage: ""
    },
    watchOverflow: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});

const hpCategorySettings = {
    loop: true,
    effect: 'fade',
    crossFade :true,
    allowTouchMove: true,
    breakpoints: {
        769: {
            allowTouchMove: false
        }
    },
    a11y: {
        enabled: true,
        slideLabelMessage: ""
    },
    watchOverflow: true
}

var sliderBedding = new Swiper('.hp-category.bedding .swiper-container', {
    ...hpCategorySettings,
    navigation: {
        nextEl: '#next-bedding',
        prevEl: '#prev-bedding',
    }
});

var sliderBath = new Swiper('.hp-category.bath .swiper-container', {
    ...hpCategorySettings,
    navigation: {
        nextEl: '#next-bath',
        prevEl: '#prev-bath',
    }
});

const skylineSwiper = (elementStr) => ({
    slidesPerView: 2,
    spaceBetween:0,
    breakpoints: {
        768: {
        slidesPerView: 3
        }
    },
    a11y: {
    enabled: true,
    slideLabelMessage: ""
    },
    navigation: {
        nextEl: `${elementStr} .swiper-button-next`,
        prevEl: `${elementStr} .swiper-button-prev`,
    }
})

var sliderFragrance = new Swiper(
    '.hp-fragrance .swiper-container',
    skylineSwiper('.hp-fragrance')
);

var sliderAmenities = new Swiper(
    '.hp-amenities .swiper-container',
    skylineSwiper('.hp-amenities')
);
